const BACKGROUND_COLOR = "#FFFFFF";

const BackgroundPlugin = {
  beforeDraw: (chart: Chart) => {
    if (chart.ctx && chart.canvas) {
      const ctx = chart.ctx;

      ctx.save();
      ctx.fillStyle = BACKGROUND_COLOR;
      ctx.fillRect(0, 0, chart.canvas.width, chart.canvas.height);
      ctx.restore();
    }
  },
};

export default BackgroundPlugin;
